import { Directive, ElementRef, Renderer2, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[appUpperCase]"
})
export class UppercaseDirective {
  constructor(
    public model: NgControl,
    public ele: ElementRef,
    public renderer: Renderer2
  ) {}
  @HostListener("blur")
  onBlur() {
    const upperValue = this.ele.nativeElement.value.toUpperCase();
    if (this.ele.nativeElement.value !== upperValue) {
      this.renderer.setProperty(this.ele.nativeElement, "value", upperValue);
      this.model.viewToModelUpdate(upperValue);
      this.model.control.setValue(upperValue);
    }
  }
}
